import UsageMonitoringSection from "@/components/monitoring-stats";
import { useAnalyticsEventNames } from "@/hooks/useAnalyticsEventNames";
import IsConnectedWrapper from "../components/IsConnectedWrapper";

export default function MonitoringPage() {
	const { data: analyticsEventNames = [] } = useAnalyticsEventNames();

	return (
		<main className="grow pb-20 px-6 font-inter min-h-[calc(100vh-500px)]">
			<div className="max-w-5xl mx-auto space-y-8">
				<IsConnectedWrapper>
					{/* Monitoring Stats */}
					<UsageMonitoringSection eventNames={analyticsEventNames} />
				</IsConnectedWrapper>
			</div>
		</main>
	);
}
